/** Original map polygon style (red outline, light fill). */
export const MAP_STYLES = {
  highlight: { color: 'red', weight: 2, fillOpacity: 0.2 },
  hidden: { fillOpacity: 0, opacity: 0, weight: 0 },
};

export const ZIPCODE_MAP_VIEW = {
  ANALYTICS: 'analytics',
  CUSTOMERS: 'customers',
  STORES: 'stores',
  BOTH: 'both',
};

export const ZIPCODE_MAP_VIEW_TABS = [
  { id: ZIPCODE_MAP_VIEW.ANALYTICS, label: 'Analytics' },
  { id: ZIPCODE_MAP_VIEW.CUSTOMERS, label: 'Customers' },
  { id: ZIPCODE_MAP_VIEW.STORES, label: 'Store' },
  { id: ZIPCODE_MAP_VIEW.BOTH, label: 'Both' },
];

export const ZIPCODE_MAP_CUSTOMER_DOT = '#000000';
export const ZIPCODE_MAP_STORE_DOT = '#EA580C';
